module.exports = __webpack_public_path__ + "img/16581257_L.c67afcd0.png";